import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CredentialsService } from '@app/@shared/services/web/credentials.service';
import { PropertiesService } from '@app/@shared/services/api/properties.service';

@Component({
  selector: 'app-remember-to-validate-modal',
  templateUrl: './remember-to-validate-modal.component.html',
  styleUrls: ['./remember-to-validate-modal.component.scss'],
})
export class RememberToValidateModalComponent implements OnInit {
  reSendEmail = false;

  constructor(
    public credentialsService: CredentialsService,
    private propertiesService: PropertiesService,
    private readonly dialogRef: MatDialogRef<RememberToValidateModalComponent>
  ) {}

  ngOnInit(): void {}

  close(): void {
    this.dialogRef.close();
  }
  reSendEmailVerification() {
    const emailUser = {
      email: this.credentialsService.credentials.email,
    };
    this.propertiesService.SendEmail(emailUser).subscribe((res) => {
      this.reSendEmail = true;
    });
  }
}
